import { h } from 'preact';
export const Pause = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("rect", { x: "6", y: "4", width: "4", height: "16" }),
        h("rect", { x: "14", y: "4", width: "4", height: "16" })));
};
//# sourceMappingURL=pause.js.map